export const content = {
    menuItems: [
        {
            menu: "Home",
            link: "/",
        },
        // {
        //     menu: "Swap",
        //     link: "/swap",
        // },
        {
            menu: "Projects",
            link: "/projects",
        },
        {
            menu: "Contact Us",
            link: "/contact-us",
        },
        {
            menu: "FAQ's",
            link: "/faq",
        },
    ],
    filterOptions: ['All', 'Ongoing', 'Past Projects'],
    projects: [
        {
            createdBy: "0x3F395304c5E4e2EEe081fa50090acDA93ec48BE3",
            createdTime: 1630000000,
            facebook: "https://www.facebook.com/project1",
            instagram: "https://www.instagram.com/project1",
            twitter: "https://twitter.com/project1",
            location: "Lahore, Pakistan",
            projectDescription: "This is a project about helping homeless people in Lahore by providing them with food, shelter, and clothing.",
            projectId: 1,
            projectName: "Helping Homeless in Lahore",
            raisedFunds: 5000,
            requiredFunds: 10000,
            socialLink: "https://www.project1.com",
            supporters: 50,
            tags: ["charity", "homeless", "Pakistan"],
            targetTime: 1635000000,
            withdrawalStatus: true
        },
        {
            createdBy: "0x3F395304c5E4e2EEe081fa50090acDA93ec48BE3",
            createdTime: 1631000000,
            facebook: "https://www.facebook.com/project2",
            instagram: "https://www.instagram.com/project2",
            twitter: "https://twitter.com/project2",
            location: "New York, USA",
            projectDescription: "This project aims to build a community center in New York City to provide educational and recreational activities for children and families.",
            projectId: 2,
            projectName: "Community Center in NYC",
            raisedFunds: 7000,
            requiredFunds: 20000,
            socialLink: "https://www.project2.com",
            supporters: 70,
            tags: ["community", "education", "New York"],
            targetTime: 1640000000,
            withdrawalStatus: false
        },
        {
            createdBy: "0x3F395304c5E4e2EEe081fa50090acDA93ec48BE3",
            createdTime: 1632000000,
            facebook: "https://www.facebook.com/project3",
            instagram: "https://www.instagram.com/project3",
            twitter: "https://twitter.com/project3",
            location: "London, UK",
            projectDescription: "A project to renovate and maintain historical landmarks in London, preserving the city's cultural heritage.",
            projectId: 3,
            projectName: "London Landmarks Preservation",
            raisedFunds: 10000,
            requiredFunds: 30000,
            socialLink: "https://www.project3.com",
            supporters: 100,
            tags: ["preserve", "history", "London"],
            targetTime: 1645000000,
            withdrawalStatus: true
        },
        {
            createdBy: "0x3F395304c5E4e2EEe081fa50090acDA93ec48BE3",
            createdTime: 1633000000,
            facebook: "https://www.facebook.com/project4",
            instagram: "https://www.instagram.com/project4",
            twitter: "https://twitter.com/project4",
            location: "Tokyo, Japan",
            projectDescription: "This project aims to promote sustainable farming practices and provide support to local farmers in rural areas of Japan.",
            projectId: 4,
            projectName: "Sustainable Farming in Japan",
            raisedFunds: 8000,
            requiredFunds: 15000,
            socialLink: "https://www.project4.com",
            supporters: 80,
            tags: ["sustain", "farming", "Japan"],
            targetTime: 1638000000,
            withdrawalStatus: false
        },
        {
            createdBy: "0x3F395304c5E4e2EEe081fa50090acDA93ec48BE3",
            createdTime: 1634000000,
            facebook: "https://www.facebook.com/project5",
            instagram: "https://www.instagram.com/project5",
            twitter: "https://twitter.com/project5",
            location: "Paris, France",
            projectDescription: "A project to provide art and music therapy programs for children with special needs in Paris.",
            projectId: 5,
            projectName: "Art & Music Therapy for Children",
            raisedFunds: 6000,
            requiredFunds: 12000,
            socialLink: "https://www.project5.com",
            supporters: 60,
            tags: ["therapy", "children", "Paris"],
            targetTime: 1642000000,
            withdrawalStatus: true
        },
        {
            createdBy: "0x3F395304c5E4e2EEe081fa50090acDA93ec48BE3",
            createdTime: 1635000000,
            facebook: "https://www.facebook.com/project6",
            instagram: "https://www.instagram.com/project6",
            twitter: "https://twitter.com/project6",
            location: "Sydney, Australia",
            projectDescription: "This project aims to plant trees and create green spaces in urban areas of Sydney to combat climate change and improve air quality.",
            projectId: 6,
            projectName: "Urban Greening in Sydney",
            raisedFunds: 9000,
            requiredFunds: 20000,
            socialLink: "https://www.project6.com",
            supporters: 90,
            tags: ["environment", "green", "Sydney"],
            targetTime: 1647000000,
            withdrawalStatus: false
        },
        {
            createdBy: "0x3F395304c5E4e2EEe081fa50090acDA93ec48BE3",
            createdTime: 1636000000,
            facebook: "https://www.facebook.com/project7",
            instagram: "https://www.instagram.com/project7",
            twitter: "https://twitter.com/project7",
            location: "Berlin, Germany",
            projectDescription: "A project to support refugees in Berlin by providing shelter, food, and educational resources.",
            projectId: 7,
            projectName: "Support for Refugees in Berlin",
            raisedFunds: 11000,
            requiredFunds: 25000,
            socialLink: "https://www.project7.com",
            supporters: 110,
            tags: ["refugees", "human", "Berlin"],
            targetTime: 1650000000,
            withdrawalStatus: true
        },
        {
            createdBy: "0x3F395304c5E4e2EEe081fa50090acDA93ec48BE3",
            createdTime: 1637000000,
            facebook: "https://www.facebook.com/project8",
            instagram: "https://www.instagram.com/project8",
            twitter: "https://twitter.com/project8",
            location: "Rio de Janeiro, Brazil",
            projectDescription: "This project aims to provide clean water access to rural communities in Brazil, improving health and sanitation.",
            projectId: 8,
            projectName: "Clean Water for Rural Brazil",
            raisedFunds: 7500,
            requiredFunds: 15000,
            socialLink: "https://www.project8.com",
            supporters: 75,
            tags: ["clean", "health", "Brazil"],
            targetTime: 1644000000,
            withdrawalStatus: false
        },
        {
            createdBy: "0x3F395304c5E4e2EEe081fa50090acDA93ec48BE3",
            createdTime: 1638000000,
            facebook: "https://www.facebook.com/project9",
            instagram: "https://www.instagram.com/project9",
            twitter: "https://twitter.com/project9",
            location: "Cape Town, South Africa",
            projectDescription: "A project to empower women entrepreneurs in Cape Town through training, mentorship, and access to financial resources.",
            projectId: 9,
            projectName: "Empowering Women in Cape Town",
            raisedFunds: 8500,
            requiredFunds: 20000,
            socialLink: "https://www.project9.com",
            supporters: 85,
            tags: ["women", "entrepreneur", "Cap"],
            targetTime: 1649000000,
            withdrawalStatus: false
        },
        {
            createdBy: "0x3F395304c5E4e2EEe081fa50090acDA93ec48BE3",
            createdTime: 1639000000,
            facebook: "https://www.facebook.com/project10",
            instagram: "https://www.instagram.com/project10",
            twitter: "https://twitter.com/project10",
            location: "Toronto, Canada",
            projectDescription: "This project aims to provide free education and vocational training for underprivileged youth in Toronto, helping them build better futures.",
            projectId: 10,
            projectName: "Education for Underprivileged Youth",
            raisedFunds: 9500,
            requiredFunds: 18000,
            socialLink: "https://www.project10.com",
            supporters: 95,
            tags: ["education", "youth", "Toronto"],
            targetTime: 1652000000,
            withdrawalStatus: true
        },
        {
            createdBy: "0x3F395304c5E4e2EEe081fa50090acDA93ec48BE3",
            createdTime: 1642000000,
            facebook: "https://www.facebook.com/project13",
            instagram: "https://www.instagram.com/project13",
            twitter: "https://twitter.com/project13",
            location: "Mexico City, Mexico",
            projectDescription: "A project to improve public transportation infrastructure in Mexico City, reducing traffic congestion and air pollution.",
            projectId: 13,
            projectName: "Public Transport Upgrade in Mexico City",
            raisedFunds: 7500,
            requiredFunds: 15000,
            socialLink: "https://www.project13.com",
            supporters: 75,
            tags: ["public", "infrastructure", "Mexico City"],
            targetTime: 1647000000,
            withdrawalStatus: false
        },
        {
            createdBy: "0x3F395304c5E4e2EEe081fa50090acDA93ec48BE3",
            createdTime: 1643000000,
            facebook: "https://www.facebook.com/project14",
            instagram: "https://www.instagram.com/project14",
            twitter: "https://twitter.com/project14",
            location: "Moscow, Russia",
            projectDescription: "A project to create public art installations and murals in Moscow, promoting cultural exchange and community engagement.",
            projectId: 14,
            projectName: "Public Art in Moscow",
            raisedFunds: 8000,
            requiredFunds: 12000,
            socialLink: "https://www.project14.com",
            supporters: 80,
            tags: ["public", "culture", "Moscow"],
            targetTime: 1650000000,
            withdrawalStatus: true
        },
        {
            createdBy: "0x3F395304c5E4e2EEe081fa50090acDA93ec48BE3",
            createdTime: 1644000000,
            facebook: "https://www.facebook.com/project15",
            instagram: "https://www.instagram.com/project15",
            twitter: "https://twitter.com/project15",
            location: "Madrid, Spain",
            projectDescription: "A project to create community gardens and green spaces in Madrid, promoting urban biodiversity and sustainable living.",
            projectId: 15,
            projectName: "Community Gardens in Madrid",
            raisedFunds: 9500,
            requiredFunds: 18000,
            socialLink: "https://www.project15.com",
            supporters: 95,
            tags: ["community", "green", "Madrid"],
            targetTime: 1652000000,
            withdrawalStatus: true
        },
        {
            createdBy: "0x3F395304c5E4e2EEe081fa50090acDA93ec48BE3",
            createdTime: 1645000000,
            facebook: "https://www.facebook.com/project16",
            instagram: "https://www.instagram.com/project16",
            twitter: "https://twitter.com/project16",
            location: "Seoul, South Korea",
            projectDescription: "A project to provide education and vocational training for unemployed youth in Seoul, empowering them to pursue career opportunities.",
            projectId: 16,
            projectName: "Empowerment for Youth in Seoul",
            raisedFunds: 7000,
            requiredFunds: 10000,
            socialLink: "https://www.project16.com",
            supporters: 70,
            tags: ["youth", "education", "Seoul"],
            targetTime: 1648000000,
            withdrawalStatus: false
        },
        {
            createdBy: "0x3F395304c5E4e2EEe081fa50090acDA93ec48BE3",
            createdTime: 1646000000,
            facebook: "https://www.facebook.com/project17",
            instagram: "https://www.instagram.com/project17",
            twitter: "https://twitter.com/project17",
            location: "Bangkok, Thailand",
            projectDescription: "A project to provide healthcare services and medical supplies to rural communities in Thailand, improving access to healthcare.",
            projectId: 17,
            projectName: "Healthcare Access in Rural Thailand",
            raisedFunds: 8500,
            requiredFunds: 15000,
            socialLink: "https://www.project17.com",
            supporters: 85,
            tags: ["healthcare", "rural", "Thailand"],
            targetTime: 1651000000,
            withdrawalStatus: true
        },
        {
            createdBy: "0x3F395304c5E4e2EEe081fa50090acDA93ec48BE3",
            createdTime: 1647000000,
            facebook: "https://www.facebook.com/project18",
            instagram: "https://www.instagram.com/project18",
            twitter: "https://twitter.com/project18",
            location: "Los Angeles, USA",
            projectDescription: "A project to provide mentorship and resources for aspiring entrepreneurs in Los Angeles, fostering innovation and economic growth.",
            projectId: 18,
            projectName: "Entrepreneurship Support in LA",
            raisedFunds: 8000,
            requiredFunds: 12000,
            socialLink: "https://www.project18.com",
            supporters: 80,
            tags: ["entrepreneurship", "mentorship", "Los Angeles"],
            targetTime: 1653000000,
            withdrawalStatus: false
        },
        {
            createdBy: "0x3F395304c5E4e2EEe081fa50090acDA93ec48BE3",
            createdTime: 1648000000,
            facebook: "https://www.facebook.com/project19",
            instagram: "https://www.instagram.com/project19",
            twitter: "https://twitter.com/project19",
            location: "Singapore",
            projectDescription: "A project to provide financial literacy education and support for low-income families in Singapore, empowering them to achieve financial stability.",
            projectId: 19,
            projectName: "Financial Literacy in Singapore",
            raisedFunds: 7500,
            requiredFunds: 10000,
            socialLink: "https://www.project19.com",
            supporters: 75,
            tags: ["financial", "low-income", "Singapore"],
            targetTime: 1654000000,
            withdrawalStatus: true
        },
        {
            createdBy: "0x3F395304c5E4e2EEe081fa50090acDA93ec48BE3",
            createdTime: 1649000000,
            facebook: "https://www.facebook.com/project20",
            instagram: "https://www.instagram.com/project20",
            twitter: "https://twitter.com/project20",
            location: "Mumbai, India",
            projectDescription: "A project to provide access to education and technology resources for children living in slums in Mumbai, empowering them to break the cycle of poverty.",
            projectId: 20,
            projectName: "Education for Slum Children in Mumbai",
            raisedFunds: 9000,
            requiredFunds: 15000,
            socialLink: "https://www.project20.com",
            supporters: 90,
            tags: ["education", "slum", "Mumbai"],
            targetTime: 1655000000,
            withdrawalStatus: false
        },
        {
            createdBy: "0x3F395304c5E4e2EEe081fa50090acDA93ec48BE3",
            createdTime: 1650000000,
            facebook: "https://www.facebook.com/project21",
            instagram: "https://www.instagram.com/project21",
            twitter: "https://twitter.com/project21",
            location: "Berlin, Germany",
            projectDescription: "A project to support mental health awareness and provide resources for individuals struggling with mental illness in Berlin.",
            projectId: 21,
            projectName: "Mental Health Support in Berlin",
            raisedFunds: 8500,
            requiredFunds: 12000,
            socialLink: "https://www.project21.com",
            supporters: 85,
            tags: ["mental", "awareness", "Berlin"],
            targetTime: 1656000000,
            withdrawalStatus: false
        },
        {
            createdBy: "0x3F395304c5E4e2EEe081fa50090acDA93ec48BE3",
            createdTime: 1651000000,
            facebook: "https://www.facebook.com/project22",
            instagram: "https://www.instagram.com/project22",
            twitter: "https://twitter.com/project22",
            location: "Sydney, Australia",
            projectDescription: "A project to restore and preserve coral reefs along the Great Barrier Reef in Australia, protecting marine biodiversity.",
            projectId: 22,
            projectName: "Coral Reef Restoration in Australia",
            raisedFunds: 9500,
            requiredFunds: 18000,
            socialLink: "https://www.project22.com",
            supporters: 95,
            tags: ["coral", "conservation", "Australia"],
            targetTime: 1657000000,
            withdrawalStatus: true
        },
        {
            createdBy: "0x3F395304c5E4e2EEe081fa50090acDA93ec48BE3",
            createdTime: 1652000000,
            facebook: "https://www.facebook.com/project23",
            instagram: "https://www.instagram.com/project23",
            twitter: "https://twitter.com/project23",
            location: "New Delhi, India",
            projectDescription: "A project to provide healthcare services and medical supplies to rural communities in India, improving access to healthcare.",
            projectId: 23,
            projectName: "Healthcare Access in Rural India",
            raisedFunds: 7000,
            requiredFunds: 10000,
            socialLink: "https://www.project23.com",
            supporters: 70,
            tags: ["healthcare", "rural", "India"],
            targetTime: 1658000000,
            withdrawalStatus: false
        },
        {
            createdBy: "0x3F395304c5E4e2EEe081fa50090acDA93ec48BE3",
            createdTime: 1653000000,
            facebook: "https://www.facebook.com/project24",
            instagram: "https://www.instagram.com/project24",
            twitter: "https://twitter.com/project24",
            location: "Tokyo, Japan",
            projectDescription: "A project to provide support and rehabilitation services for survivors of natural disasters in Japan, aiding in their recovery.",
            projectId: 24,
            projectName: "Disaster Relief in Japan",
            raisedFunds: 8000,
            requiredFunds: 12000,
            socialLink: "https://www.project24.com",
            supporters: 80,
            tags: ["disaster", "rehabilitation", "Japan"],
            targetTime: 1659000000,
            withdrawalStatus: true
        },
        {
            createdBy: "0x3F395304c5E4e2EEe081fa50090acDA93ec48BE3",
            createdTime: 1654000000,
            facebook: "https://www.facebook.com/project25",
            instagram: "https://www.instagram.com/project25",
            twitter: "https://twitter.com/project25",
            location: "Paris, France",
            projectDescription: "A project to provide art and music education programs for children from underserved communities in Paris, fostering creativity and expression.",
            projectId: 25,
            projectName: "Art & Music Education in Paris",
            raisedFunds: 7500,
            requiredFunds: 10000,
            socialLink: "https://www.project25.com",
            supporters: 75,
            tags: ["art", "education", "Paris"],
            targetTime: 1660000000,
            withdrawalStatus: false
        },
        {
            createdBy: "0x3F395304c5E4e2EEe081fa50090acDA93ec48BE3",
            createdTime: 1655000000,
            facebook: "https://www.facebook.com/project26",
            instagram: "https://www.instagram.com/project26",
            twitter: "https://twitter.com/project26",
            location: "London, UK",
            projectDescription: "A project to provide food and shelter for homeless individuals in London, addressing issues of homelessness and poverty.",
            projectId: 26,
            projectName: "Homeless Support in London",
            raisedFunds: 8500,
            requiredFunds: 15000,
            socialLink: "https://www.project26.com",
            supporters: 85,
            tags: ["homeless", "poverty", "London"],
            targetTime: 1661000000,
            withdrawalStatus: true
        },
        {
            createdBy: "0x3F395304c5E4e2EEe081fa50090acDA93ec48BE3",
            createdTime: 1656000000,
            facebook: "https://www.facebook.com/project27",
            instagram: "https://www.instagram.com/project27",
            twitter: "https://twitter.com/project27",
            location: "New York, USA",
            projectDescription: "A project to provide educational scholarships and support for low-income students in New York City, enabling access to higher education.",
            projectId: 27,
            projectName: "Scholarships for Low-Income Students",
            raisedFunds: 9000,
            requiredFunds: 12000,
            socialLink: "https://www.project27.com",
            supporters: 90,
            tags: ["scholarships", "education", "New York"],
            targetTime: 1662000000,
            withdrawalStatus: false
        },
        {
            createdBy: "0x3F395304c5E4e2EEe081fa50090acDA93ec48BE3",
            createdTime: 1657000000,
            facebook: "https://www.facebook.com/project28",
            instagram: "https://www.instagram.com/project28",
            twitter: "https://twitter.com/project28",
            location: "Mumbai, India",
            projectDescription: "A project to empower women from marginalized communities in Mumbai through vocational training and entrepreneurship support.",
            projectId: 28,
            projectName: "Empowering Women in Mumbai",
            raisedFunds: 8000,
            requiredFunds: 15000,
            socialLink: "https://www.project28.com",
            supporters: 80,
            tags: ["women empowerment", "entrepreneurship", "Mumbai"],
            targetTime: 1663000000,
            withdrawalStatus: true
        },
        {
            createdBy: "0x3F395304c5E4e2EEe081fa50090acDA93ec48BE3",
            createdTime: 1658000000,
            facebook: "https://www.facebook.com/project29",
            instagram: "https://www.instagram.com/project29",
            twitter: "https://twitter.com/project29",
            location: "Rio de Janeiro, Brazil",
            projectDescription: "A project to promote environmental conservation and sustainability practices in Rio de Janeiro, Brazil.",
            projectId: 29,
            projectName: "Environmental Conservation in Rio",
            raisedFunds: 9500,
            requiredFunds: 18000,
            socialLink: "https://www.project29.com",
            supporters: 95,
            tags: ["environment", "conservation", "Rio"],
            targetTime: 1664000000,
            withdrawalStatus: false
        },
        {
            createdBy: "0x3F395304c5E4e2EEe081fa50090acDA93ec48BE3",
            createdTime: 1659000000,
            facebook: "https://www.facebook.com/project30",
            instagram: "https://www.instagram.com/project30",
            twitter: "https://twitter.com/project30",
            location: "Cape Town, South Africa",
            projectDescription: "A project to provide access to clean water and sanitation facilities for rural communities in Cape Town, South Africa.",
            projectId: 30,
            projectName: "Clean Water in Rural Cape Town",
            raisedFunds: 7000,
            requiredFunds: 10000,
            socialLink: "https://www.project30.com",
            supporters: 70,
            tags: ["water", "sanitation", "Town"],
            targetTime: 1665000000,
            withdrawalStatus: true
        }
    ],
}